import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { useContinueRedirect } from 'applicationTable/useContinueRedirect.hook';
import { useAmplitude } from 'hooks/useAmplitude';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';

type TProps = {
  stateKey: string;
  applicationId: string;
};

export const ContinueApplicationButton = ({
  stateKey,
  applicationId,
}: TProps) => {
  const { trackEvent } = useAmplitude();

  const { handleRedirect, getRedirectUrl, redirectionId } =
    useContinueRedirect();

  const handleOpenApplicationTracking = () => {
    trackEvent(AMPLITUDE_EVENTS.dashboardCTAClicked, {
      Status: 'Open',
    });

    trackEvent(AMPLITUDE_EVENTS.signupCTAClicked, {
      'CTA location': 'Application table',
      'CTA text': 'Continue app',
      'CTA URL': getRedirectUrl(applicationId),
    });
  };

  return (
    <Button
      loading={redirectionId === stateKey}
      size="small"
      ref={(ref) => {
        // https://stackoverflow.com/a/24421834
        // React uses event delegation with a single event listener on document for events that bubble, which means stopping propagation is not possible;
        // the real event has already propagated by the time you interact with it in React. StopPropagation on React's synthetic event is possible because
        // React handles propagation of synthetic events internally.
        if (!ref) return;

        ref.onclick = (e) => {
          e.stopPropagation();
          handleOpenApplicationTracking();
          handleRedirect(stateKey, applicationId);
        };
      }}
    >
      <Trans>Continue app</Trans>
    </Button>
  );
};
